import * as Yup from "yup"

export const validationSchemaForSimulate = Yup.object({
    eventType: Yup.string().required('Enter Event Type'),
    uom: Yup.object().required('Select UOM'),
    usageValue: Yup.number().typeError('It doesn\'t look like a number').positive('A number can\'t start with a minus').integer('It can\'t include a decimal point').required('Enter Usage Value'),
    eventStartTime: Yup.date().required('Select Start Time'),
    eventEndTime: Yup.date().required('Select End Time'),
})

export const validationSchemaForCustomer = (customerPermission, state, id, isEIPEnabled) => {
    let validationSchema = {}
    return validationSchema = Yup.object({
      firstName: Yup.string()
  .required(`Enter ${isEIPEnabled ? "Device" : "Customer"}'s First Name`)
  .matches(
    /^[a-zA-Z0-9\s_+]*$/,
    "Firstname can contain only characters, numbers, space, underscore and +"
  ),

lastName: Yup.string()
  .required(`Enter ${isEIPEnabled ? "Device" : "Customer"}'s Last Name`)
  .matches(
    /^[a-zA-Z0-9\s_+]*$/,
    "Lastname can contain only characters, numbers, space, underscore and +"
  ),
        userName: Yup.string().required(`Enter ${isEIPEnabled ? "Device" : "Customer"}'s User Name`),
        email: Yup.string().email('Enter a Valid Email').required(`Enter ${isEIPEnabled ? "Device" : "Customer"}'s Email Address`),
        // mobile: Yup.number().typeError('It doesn\'t look like a mobile number').positive('A phone number can\'t start with a minus').integer('It can\'t include a decimal point').test('len', 'Must be exactly 10 digits', val => val?.toString().length === 10).required('Kindly enter Phone Number'),
        // imsi: customerPermission.autoload ? Yup.number().required('Kindly enter IMSI').test('len', 'Must be exactly 15 digits', val => val?.toString().length === 15) : Yup.number(),
        ...( !id && {accountNumber: customerPermission?.has("autoload") ? Yup.string().required(`Enter ${isEIPEnabled ? "Device" : "Customer"}'s Account Number`).matches(/^[0-9a-zA-Z]+$/, 'Account Number can contain only characters and digits').min(4, "Must be more than or equal to 4 characters").max(32, "Must be less than or equal to 32 characters") : Yup.string()}),
        bdom: customerPermission?.has("autoload")  ? Yup.object().required('Select BDOM (Billing Day of Month)') : Yup.object(),
        addressLine1: Yup.string().max(30, 'Must be 30 characters or less').required(`Enter ${isEIPEnabled ? "Device" : "Customer"}'s Address`),
        country: Yup.object().required("Kindly select Country"),
        city: Yup.object().required('Kindly select City'),
        state: Yup.object().required('Kindly select State'),
        zipCode: Yup.number().typeError('It doesn\'t look like a zip code').positive('A zip code can\'t start with a minus').integer('It can\'t include a decimal point').required('Enter Your Zip Code'),
        documentType: state ? Yup.object().required('Kindly select document type') : Yup.object(),
        documentName: state ? Yup.string().required('Kindly enter the document name') : Yup.string(),
        selectedFile: state ? Yup.mixed().required('Kindly select a file') : Yup.mixed(),
    }, []);
}

export const validationSchemaForTelcoSimulate = (match, action) =>
    Yup.object({
        subscriptionId: Yup.object().required('Select the Subscription'),
        usageEventType: Yup.object().required('Enter Event Type'),
        sessionId: Yup.string().required('Enter Session Id'),
        sessionTime: Yup.date().required('Select Session Time'),

        // only require requestedUnits & uom when action is NOT terminate and match is false
        ...(!match && action !== 'terminate' && {
            requestedUnits: Yup.number().required('Enter Requested Units'),
            uom: Yup.object().required('Select UOM')
        }),

        // only require sequence for update
        ...(action === 'update' && {
            sequence: Yup.number().required('Enter Sequence')
        })
    });

export const validationSchemaForUpdateSimulate = (terminateSessions) =>
    Yup.object({
        sessionId: Yup.string().required('Select the Subscription'),
        sequence:!terminateSessions? Yup.string().required('Enter Event Type'):Yup.string(),
        sessionTime: Yup.date().required('Select Session Time'),
        // requestedUnits:!terminateSessions? Yup.number().typeError('It doesn\'t look like a number').positive('A number can\'t start with a minus').integer('It can\'t include a decimal point').required('Kindly enter Requested Units'):Yup.string(),
        //  usedUnits:!terminateSessions?Yup.string(): Yup.number().typeError('It doesn\'t look like a number').min(0, 'The value cannot be negative').integer('It can\'t include a decimal point').required('Kindly enter Used Units'),
    })
export const validationSchemaForPassword = Yup.object({
    newPassword: Yup.string()
      .required('Please enter your new password')
      .min(8, 'Password must be at least 8 characters long')
      .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
      .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
      .matches(/[0-9]/, 'Password must contain at least one number')
      .matches(/[@$!%*?&#]/, 'Password must contain at least one special character')
      .matches(/^\S*$/, 'Password cannot contain spaces'),
    confirmNewPassword: Yup.string()
      .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
      .required('Please confirm your password'),
  })

let initialValues = {
    sessionId: '',
    sequence: '',
    sessionTime: null,
    requestedUnits: '',
    usedUnits: '',

};

export const validationSchemaForAdjustment = Yup.object().shape({
  adjustmentAmount: Yup.number()
    .required("Adjustment amount is required"),
  resourceName: Yup.string()
    .required("Resource name is required"),
  description: Yup.string(),
  balanceItemSpecId: Yup.string()
    .test(
      "balance-or-offer-sub-check",
      "Balance Item Spec ID is required",
      function (value) {
        const { offerCode, subscriptionId } = this.parent;
        const hasBalance = !!value?.trim();
        const hasOfferAndSub = !!offerCode?.trim() && !!subscriptionId?.trim();
        return hasBalance || hasOfferAndSub;
      }
    ),

  offerCode: Yup.string()
    .test(
      "offer-sub-or-balance-check",
      "OfferCode is required",
      function (value) {
        const { balanceItemSpecId, subscriptionId } = this.parent;
        const hasBalance = !!balanceItemSpecId?.trim();
        const hasOfferAndSub = !!value?.trim() && !!subscriptionId?.trim();
        return hasBalance || hasOfferAndSub;
      }
    ),

  subscriptionId: Yup.string()
    .test(
      "sub-offer-or-balance-check",
      "SubscriptionId is required",
      function (value) {
        const { balanceItemSpecId, offerCode } = this.parent;
        const hasBalance = !!balanceItemSpecId?.trim();
        const hasOfferAndSub = !!offerCode?.trim() && !!value?.trim();
        return hasBalance || hasOfferAndSub;
      }
    ),
});

export const validationSchemaForRecharge = Yup.object().shape({
  adjustmentAmount: Yup.number()
    .required("Recharge amount is required"),
  resourceName: Yup.string()
    .required("Resource name is required"),
});

export const validationSchemaForCurrencyAdjustment = Yup.object().shape({
  adjustmentAmount: Yup.number()
    .required("Adjustment amount is required"),
  resourceName: Yup.string()
    .required("Resource name is required"),
  description: Yup.string(),
});